module.exports = __webpack_public_path__ + "IL.png?b71a8cf9e7f8031793af07faffa8c330";